import { getAccessToken } from '@memorai/auth/client';
import type { SupabaseClient } from '@supabase/supabase-js';

interface ApiClientOptions {
    apiUrl: string;
    supabase: SupabaseClient;
}

interface RequestOptions extends RequestInit {
    headers?: Record<string, string>;
}

let apiUrl = '';
let supabaseClient: SupabaseClient | null = null;

export function initApiClient(options: ApiClientOptions): void {
    apiUrl = options.apiUrl;
    supabaseClient = options.supabase;
}

export function getApiClientState() {
    return {
        apiUrl,
        initialized: Boolean(apiUrl && supabaseClient),
    };
}

export async function apiFetch<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
    if (!apiUrl || !supabaseClient) {
        throw new Error('API client not initialized. Call initApiClient() before using API hooks.');
    }

    const token = await getAccessToken(supabaseClient);
    const headers = {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
    };

    const response = await fetch(`${apiUrl}${endpoint}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || errorData.message || `API Error: ${response.statusText}`);
    }

    if (response.status === 204) {
        return {} as T;
    }

    return response.json();
}
